// https://vuex.vuejs.org/en/state.html

export default {
    //
    isLoggedIn: !!localStorage.getItem("jwt")
}
